import type { DbClient } from '../../../../lib/db.js';
import { ROLE_KEYS } from '../../../../permissions/index.js';

/** The tenant-admin set — `company-owner` before 202609111100 renamed it. */
const COMPANY_OWNER_ROLE_KEY: string = ROLE_KEYS.COMPANY_ADMIN;

export interface CompanyOwnerRow {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
}

/**
 * Full-row counterpart of `companyHasOwnerDb`. IAM-native: an admin-set
 * grant in `iam_actor_roles`/`iam_roles` is created for a membership
 * regardless of whether that company is the holder's *primary* one, so the
 * legacy two-branch `UNION` (one keyed off `users.primary_role` +
 * `primary_company_id`, the other off `user_companies.role`) collapses into a
 * single IAM membership check. Extended with `first_name`/`last_name` so
 * callers (e.g. the company-join-request-created notification handler) can
 * fan out to every owner without a second lookup.
 */
export const getCompanyOwnersDb = async (
  db: DbClient,
  companyId: string,
): Promise<CompanyOwnerRow[]> => {
  return db.runSql<CompanyOwnerRow>(
    `
    SELECT DISTINCT users.id, users.email, users.first_name, users.last_name
    FROM users
    JOIN iam_actor_roles iar ON iar.actor_type = 'user' AND iar.actor_id = users.id
    JOIN iam_roles ir ON ir.id = iar.role_id
    WHERE ir.tenant_id = $1
    AND ir.key = $2
    AND users.is_blocked = 0
    `,
    [companyId, COMPANY_OWNER_ROLE_KEY],
  );
};
